import styled from '@emotion/styled';
import {
  Card,
  Flex,
  colorPalettes,
  colors,
  getColor
} from '@linearb/linui-common';
import { Grid } from '@mui/material';

export const CardStyledControllerContainer = styled(Flex)`
  padding: 2rem 4rem;
  flex-direction: column;
`;

export const CardContainerContent = styled(Grid)`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  row-gap: 3.3077rem;
  column-gap: 1.7692rem;

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 0.4615rem;
`;

export const CardSubheader = styled.div`
  font-family: 'Share Tech Mono';
  font-style: normal;
  font-weight: 400;
  font-size: 1.25rem;
  color: ${getColor(colors.portage)};

  /* This has to be set in pixels in order for "text-overflow" to work */
  max-width: 300px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const CardSection = styled.div`
  display: flex;
  gap: 0.5rem;
  font-style: normal;
  font-weight: 400;
  font-size: 1.0769rem;
  line-height: 1.3846rem;
  height: 1.3846rem;
  padding: 0.4038rem 0;
`;

export const AutomationsRunSection = styled(CardSection)`
  gap: 0.5385rem;
`;

export const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
  min-height: 16.9231rem;
  padding: 1.25rem;
  color: ${({ theme }) => colorPalettes[theme.palette.mode].text.primary};
  border: 1px solid
    ${({ theme }) => colorPalettes[theme.palette.mode].card.border};
`;

export const StyledLoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 3rem 0 0.5rem 0;
`;

export const StyledLabelWrapper = styled.div`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;
